import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import * as logger from 'universal-logger';
import { selectUserDetectedLocation, selectUserSelectedLocation } from 'redux/modules/locale';
import { glsLocation } from 'redux/saga/entities/bound';
import { GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS } from 'constants/promotions';
import { deepExtract } from 'helpers/deep';
import { setMsaId } from 'redux/modules/features/homepage';
import { loadActivePromotion } from 'redux/saga/helpers/promotions';

export const PRODUCT_TYPES = {
  custom: 'custom',
  promotion: 'promotion',
};

export const PRODUCT_GROUP_DISCLAIMER_TYPES = {
  none: 'none',
  autoRenewal: 'auto-renewal',
};

export const LOAD_CARD_DATA = 'ProductGroup/LOAD_CARD_DATA';

export const loadCardData = ({ productType, productCode } = {}) => ({
  type: LOAD_CARD_DATA,
  productType,
  productCode,
});

export function* doLoadCardData(client, { productType, productCode }) {
  switch (productType) {
    case PRODUCT_TYPES.promotion: {
      const promoAlias = productCode || GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS;
      yield call(loadActivePromotion, client, promoAlias);
      break;
    }
    case PRODUCT_TYPES.custom:
    default:
      // do nothing since the container will pull values from the
      // module properties to populate the card
      break;
  }
}

export function* doLoadLocationData(client) {
  const locations = yield all([select(selectUserDetectedLocation), select(selectUserSelectedLocation)]);

  try {
    const [userDetectedLocation, userSelectedLocation] = yield all(
      locations.filter(Boolean).map(({ lat, lon }) => call(fetchEntityIfNeeded, glsLocation, [client, lat, lon]))
    );

    yield put(setMsaId(deepExtract('msa.id', userSelectedLocation || userDetectedLocation)));
  } catch (error) {
    yield call(logger.error, 'ProductGroup: Could not fetch location using GLS', locations, error);
  }
}

export function* loadSaga(client, props) {
  const { productType, productCode } = props;
  yield call(doLoadLocationData, client);
  yield call(doLoadCardData, client, { productType, productCode });
}

export function* watchSaga(client) {
  yield takeEvery(loadCardData().type, loadSaga, client);
}
